import React, { useEffect, useState } from "react";
import { message,Spin } from "antd";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from '../../../service/app_service'
import TopBarComponent from './../component/topbar_component'
import ModalComponent from './../component/modal_component'


import AuthenticationService from '../../../service/authentication_service'

import {SettlementAccount } from 'tradexsafely-components'
import 'tradexsafely-components/dist/index.css'

const ProfilePage = () => {

    const [loading, setLoading] = useState(false);
    const [profileTab, setProfileTab] = useState(1);
    const [accountDetail, setAccountDetail] = useState(null);
    const [showModal, setShowModal] = useState(null);
    const [banks, setBanks] = useState(null);
    const [bankDetail, setBankDetail] = useState({});

    useEffect(() => {

        getAccountDetail();
        getBanks();
        //eslint-disable-next-line
    }, []);


    const getAccountDetail = () => {
        setLoading(true);
        AppService.getAccountDetail().then(response => {
            setLoading(false)
            if (response.code) {
                message.error(response.description);
            } else {
                setAccountDetail(response);
            }

        })
    }

    const editBankAccount = () => {
        setShowModal(true);
    }

    const handleChange = (e) => {

        let data = bankDetail;
        data[e.target.name] = e.target.value;
        setBankDetail(data);

    }

    const handleBankChange = (e) => {
        var item = e.target.value;
        var item = new Array();
        item = e.target.value.split(":");

        let data = bankDetail;
        data.outBankName = item[1];
        data.outBankCode = item[0];
        setBankDetail(data);

    }



    const getBanks = () => {


        AppService.getBanks().then(response => {
            setLoading(false)
            if (response.code) {
                message.error(response.description);
            } else {
                setBanks(response);
            }

        })
    }



    const updateAccountDetail = () => {
        AppService.updateAccountDetail(bankDetail).then(response => {
            setLoading(false)
            if (response.code) {
                message.error(response.description);
            } else {
                getAccountDetail();
            }

        })

    }

    const settlementAction = (result) => {
        // console.log(result);
        message.success("Settlement account retrieved/updated successfully !!!")
        getAccountDetail()
    }

    let settlementStyleData = {};
    settlementStyleData.class = "btn btn-success btn-block";
    settlementStyleData.cover = "a";
    settlementStyleData.title = "Update Settlement Account";


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <Spin spinning={loading}>
                <div className="container">
                    <div className="row">
                        <div className="main-content col-lg-8">
                            <div className="content-area card">
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">Profile Details</h4>
                                    </div>
                                    <ul className="nav nav-tabs nav-tabs-line" role="tablist">
                                        <li className="nav-item"><a className={"nav-link " + (profileTab === 1 ? "show active" : "")} onClick={() => setProfileTab(1)} data-toggle="tab" >Personal Data</a></li>
                                        <li className="nav-item"><a className={"nav-link " + (profileTab === 2 ? "show active" : "")} onClick={() => setProfileTab(2)} data-toggle="tab" >Settings</a></li>
                                        {/* <li className="nav-item"><a className={"nav-link " + (profileTab === 3 ? "show active" : "")} onClick={() => setProfileTab(3)} data-toggle="tab" >Password</a></li> */}
                                    </ul>
                                    {/* .nav-tabs-line */}
                                    <div className="tab-content" id="profile-details">
                                        <div className={"tab-pane fade " + (profileTab === 1 ? "show active" : "")} id="personal-data">
                                            <form action="#">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="input-item input-with-label"><label htmlFor="full-name" className="input-item-label">Full Name</label><input className="input-bordered" type="text" id="full-name" disabled name="full-name" defaultValue={accountDetail && accountDetail.user && (accountDetail.user.firstName + ' '+ accountDetail.user.lastName)} /></div>
                                                        {/* .input-item */}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-item input-with-label"><label htmlFor="email-address" className="input-item-label">Email Address</label><input className="input-bordered" type="text" id="email-address" disabled name="email-address" defaultValue={accountDetail && accountDetail.user && accountDetail.user.emailAddress} /></div>
                                                        {/* .input-item */}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-item input-with-label"><label htmlFor="mobile-number" className="input-item-label">Mobile Number</label><input className="input-bordered" type="text" id="mobile-number" disabled name="mobile-number" defaultValue={accountDetail && accountDetail.user && accountDetail.user.mobileNumber} /></div>
                                                        {/* .input-item */}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-item input-with-label"><label htmlFor="date-of-birth" className="input-item-label">Date of Birth</label><input className="input-bordered date-picker-dob" type="text" id="date-of-birth" name="date-of-birth" defaultValue={accountDetail && accountDetail.user && accountDetail.user.dob} /></div>
                                                        {/* .input-item */}
                                                    </div>
                                                    {/* .col */}
                                                    <div className="col-md-6">
                                                        {/* <div className="input-item input-with-label">
                                                            <label htmlFor="nationality" className="input-item-label">Nationality</label>
                                                            <select className="input-bordered" name="nationality" id="nationality" >
                                                                <option value="nigeria">Nigeria</option>
                                                                <option value="ghana">Ghana</option>
                                                                <option value="kenya">Kenya</option>
                                                            </select>
                                                            
                                                        </div> */}
                                                        {/* .input-item */}
                                                    </div>
                                                    {/* .col */}
                                                </div>
                                                {/* .row */}
                                                <div className="gaps-1x" />
                                                {/* 10px gap */}
                                                <div className="d-sm-flex justify-content-between align-items-center">
                                                    {/* <button className="btn btn-primary">Update Profile</button> */}
                                                    <div className="gaps-2x d-sm-none" />
                                                    {/* <span className="text-success"><em className="ti ti-check-box" /> All Changes are saved</span> */}
                                                </div>
                                            </form>
                                            {/* form */}
                                        </div>
                                        {/* .tab-pane */}
                                        <div className={"tab-pane fade " + (profileTab === 2 ? "show active" : "")} id="settings">
                                            <div className="pdb-1-5x">
                                                <h5 className="card-title card-title-sm text-dark">Security Settings</h5>
                                            </div>
                                            <div className="input-item"><input type="checkbox" className="input-switch input-switch-sm" id="save-log" defaultChecked /><label htmlFor="save-log">Save my Activities Log</label></div>
                                            <div className="input-item"><input type="checkbox" className="input-switch input-switch-sm" id="pass-change-confirm" /><label htmlFor="pass-change-confirm">Confirm me through email before password change</label></div>
                                            <div className="pdb-1-5x">
                                                <h5 className="card-title card-title-sm text-dark">Manage Notification</h5>
                                            </div>
                                            <div className="input-item"><input type="checkbox" className="input-switch input-switch-sm" id="latest-news" defaultChecked /><label htmlFor="latest-news">Notify me by email about sales and latest news</label></div>
                                            <div className="input-item"><input type="checkbox" className="input-switch input-switch-sm" id="activity-alert" defaultChecked /><label htmlFor="activity-alert">Alert me by email for unusual activity.</label></div>
                                            <div className="gaps-1x" />
                                            <div className="d-flex justify-content-between align-items-center"><span /><span className="text-success"><em className="ti ti-check-box" /> Setting has been updated</span></div>
                                        </div>
                                        {/* .tab-pane */}
                                        <div className={"tab-pane fade " + (profileTab === 3 ? "show active" : "")} id="password">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="input-item input-with-label"><label htmlFor="old-pass" className="input-item-label">Old Password</label><input className="input-bordered" type="password" id="old-pass" name="old-pass" /></div>
                                                    {/* .input-item */}
                                                </div>
                                                {/* .col */}
                                            </div>
                                            {/* .row */}
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="input-item input-with-label"><label htmlFor="new-pass" className="input-item-label">New Password</label><input className="input-bordered" type="password" id="new-pass" name="new-pass" /></div>
                                                    {/* .input-item */}
                                                </div>
                                                {/* .col */}
                                                <div className="col-md-6">
                                                    <div className="input-item input-with-label"><label htmlFor="confirm-pass" className="input-item-label">Confirm New Password</label><input className="input-bordered" type="password" id="confirm-pass" name="confirm-pass" /></div>
                                                    {/* .input-item */}
                                                </div>
                                                {/* .col */}
                                            </div>
                                            {/* .row */}
                                            <div className="note note-plane note-info pdb-1x">
                                                <em className="fas fa-info-circle" />
                                                <p>Password should be minmum 8 letter and include lower and uppercase letter.</p>
                                            </div>
                                            <div className="gaps-1x" />
                                            {/* 10px gap */}
                                            <div className="d-sm-flex justify-content-between align-items-center">
                                                <button className="btn btn-primary">Update</button>
                                                <div className="gaps-2x d-sm-none" />
                                                <span className="text-success"><em className="ti ti-check-box" />  Changed Password</span>
                                            </div>
                                        </div>
                                        {/* .tab-pane */}
                                    </div>
                                    {/* .tab-content */}
                                </div>
                                {/* .card-innr */}
                            </div>
                            {/* .card */}
                            <div className="content-area card">
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">Two-Factor Verification</h4>
                                    </div>
                                    <p>Two-factor authentication is a method for protection your web account. When it is activated you need to enter not only your password, but also a special code. You can receive this code by in mobile app. 
                                        Even if third person will find your password, they can't access with that code.</p>
                                    <p>Scan the code on google authenticator app</p>
                                    {<div className="d-sm-flex justify-content-between align-items-center pdt-1-5x">
                                        <span className="text-light ucap d-inline-flex align-items-center"><span className="mb-0"><small>Current Status:</small></span> <span className="badge badge-disabled ml-2">Disabled</span></span>
                                        <div className="gaps-2x d-sm-none" />
                                        {accountDetail && accountDetail.user && <img width={200} src={accountDetail.user.qrLink} />}
                                                                            
                                        {/* <button className="order-sm-first btn btn-primary">Enable 2FA</button> */}
                                    </div>}
                                </div>
                                {/* .card-innr */}
                            </div>
                            {/* .card */}
                        </div>
                        {/* .col */}
                        <div className="aside sidebar-right col-lg-4">
                            <div className="account-info card">
                                <div className="card-innr">
                                    <h6 className="card-title card-title-sm">Your Account Status</h6>
                                    <ul className="btn-grp">
                                        <li><a  className={"btn btn-auto btn-xs "+ ((accountDetail && accountDetail.emailVerified) ? "btn-success" : "btn-warning")}>Email Verified</a></li>
                                        <li><a  className={"btn btn-auto btn-xs "+ ((accountDetail && accountDetail.phoneVerified) ? "btn-success" : "btn-warning")}>Phone Verified</a></li>
                                    </ul>
                                    <div className="gaps-2-5x" />
                                    {/* <h6 className="card-title card-title-sm">Settlement Account</h6>
                                    <div className="d-flex justify-content-between">
                                        <span>
                                            <span>0x39deb3.....e2ac64rd</span>
                                            <em className="fas fa-info-circle text-exlight" data-toggle="tooltip" data-placement="bottom" title data-original-title="1 ETH = 100 TWZ" />
                                        </span>
                                        <a href="#" data-toggle="modal" data-target="#edit-wallet" className="link link-ucap">Edit</a>
                                    </div> */}
                                </div>
                            </div>
                            {/* <div className="referral-info card">
                                <div className="card-innr">
                                    <h6 className="card-title card-title-sm">Earn with Referral</h6>
                                    <p className=" pdb-0-5x">Invite your friends &amp; family and receive a <strong><span className="text-primary">bonus - 15%</span> of the value of contribution.</strong></p>
                                    <div className="copy-wrap mgb-0-5x"><span className="copy-feedback" /><em className="fas fa-link" /><input type="text" className="copy-address" defaultValue="https://demo.themenio.com/ico?ref=7d264f90653733592" disabled /><button className="copy-trigger copy-clipboard" data-clipboard-text="https://demo.themenio.com/ico?ref=7d264f90653733592"><em className="ti ti-files" /></button></div>
                                   
                                </div>
                            </div> */}
                            {/* <div className="kyc-info card">
                                <div className="card-innr">
                                    <h6 className="card-title card-title-sm">Settlement Acount</h6>
                                    <p>Settlement account is the bank account that is used to settle transactions between participants in a trade.</p>
                                    <p className="-">Account Name : <strong>{accountDetail && accountDetail.outAccountName}</strong> </p>
                                    <p className="">Bank : <strong>{accountDetail && accountDetail.outBankName}</strong> </p>
                                    <p className="">Account Number : <strong>{accountDetail && accountDetail.outAccountNo}</strong> </p>
                                    <SettlementAccount mobileNumber={AuthenticationService.getMobileNumber()} callback={(data) => settlementAction(data)} title="Settlement" styleData={settlementStyleData} />

                                    <h6 className="kyc-alert text-danger">* You will be paid into this account when you withdraw</h6>
                                </div>
                            </div> */}
                        </div>
                        {/* .col */}
                    </div>
                    
                    {/* .container */}
                </div>
                </Spin>
                {/* .container */}
            </div>



            {showModal && <ModalComponent show={showModal} closeModal={() => setShowModal(!showModal)} title="Settlement Account" >
                <div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-item input-with-label">
                                <label className="input-item-label">Account Name</label>
                                <input type="text" className="input-bordered" value={accountDetail && accountDetail.outAccountName} onChange={handleChange} placeholder="Account name" name="outAccountName" />
                            </div>



                            <div className="input-item input-with-label">
                                <label className="input-item-label">Bank</label>
                                <div className="select-wrapper">
                                    <select name="role" className="input-bordered" name="outBankName" onChange={handleBankChange} >
                                        <option key="nothing" value="" >Select bank</option>
                                        {banks && banks.length > 0 && banks.map(function (item, idx) {
                                            return (<option key={idx} value={item.BankCode + ":" + item.BankName}>{item.BankName}</option>)
                                        })
                                        }
                                    </select>
                                </div>
                            </div>



                        </div>
                        <div className="col-md-6">
                            <div className="input-item input-with-label">
                                <label className="input-item-label">Account NumbeR</label>
                                <input type="text" className="input-bordered" value={accountDetail && accountDetail.outAccountNo} onChange={handleChange} placeholder="Account number" name="outAccountNo" />
                            </div>
                        </div>
                        <div className="col-md-12">

                            <SettlementAccount mobileNumber={AuthenticationService.getMobileNumber()} callback={(data) => settlementAction(data)} title="Settlement" styleData={settlementStyleData} />
                        </div>

                    </div>

                </div>
            </ModalComponent>}


        </div>
    );

}

export default withRouter(ProfilePage);
